import { React, useState } from 'react';
import { useUserContext } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Image, Form, Button, Stack } from 'react-bootstrap';
import * as api from 'services/api';
import './Login.css';
import { jwtDecode } from "jwt-decode";
import { useConfig } from 'contexts/ConfigContext';
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

export function Login2fa() {
    const location = useLocation();
    const { twoFAToken } = location.state || {};
    const { t } = useTranslation();
    const { configData } = useConfig();
    const navigate  = useNavigate ();
    const { updateUser } = useUserContext();
    const [twoFAAuth, setTwoFAAuth] = useState({ 
        twoFACode: '', 
        twoFAToken: twoFAToken
    });

  const [error, setError] = useState('');

  const handleAccessCodeChange = (event) => {
      setTwoFAAuth({ ...twoFAAuth, twoFACode: event.target.value });
  };


  const handleLogin = async (event) => {
    event.preventDefault();

    try {
        if (!twoFAAuth.twoFACode) {
          setError(t('userRequired'));
        return;
      }

      const response = await api.login2fa(twoFAAuth.twoFACode, twoFAAuth.twoFAToken);
      
      if (response.status === 200) {
        setError('');      
        
        localStorage.setItem('token', response.data.token);   
        const decoded = jwtDecode(response.data.token);
        const user = await api.getUserAccount();  

        const responseLC = await api.getLastConnection(user.data.personId);

        const userData = { ...user.data, controlCentreId: decoded.ControlCentreId, lastConnection: responseLC.data };   

        updateUser(userData);
        navigate('/home');
      } else {
          setError( t('wrong2fa') );
      }
    } catch (error) {
      setError('Error en la conexión');
    }
  };

  return (
    <Container fluid className="Login" style={{ height: '100vh' }}>
      <Row className="justify-content-center align-items-center h-100">
        <Col xs={12} sm={8} md={6} lg={4} className="text-center">
          <Image src="./images/tunstall-logo.png" fluid style={{ maxHeight: 'auto', maxWidth: '180px' }} />
          <h5 className="mt-2">{t('2faAuth')}</h5>
          <p className="mt-2">{t('2faAuthMessage')}</p>
          <Form className="mt-5 mx-auto" style={{ maxWidth: '340px' }} onSubmit={handleLogin}>
            <Form.Group className="mb-3" controlId="user.accessCode">
              <Stack direction="vertical">
                <Form.Label className="small text-start">{t('2faCode')}</Form.Label>
                <Form.Control type="text" placeholder={t('2faCode')} className="form-control form-control-lg bg-light" style={{ maxWidth: '100%' }} value={twoFAAuth.twoFACode} onChange={handleAccessCodeChange} autoComplete="accessCode"/>
              </Stack>
            </Form.Group>
            <Stack direction="horizontal" className="justify-content-start">
              {error && <p className="text-danger fw-semibold">{error}</p>}
            </Stack>
            <Button type="submit" variant="dark" size="lg" className="mt-3">{t('login')}</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
